import React from "react";
import {
    Phone,
    Mail,
    MapPin,
    Globe,
    Send,
    Instagram,
    Youtube,
    Linkedin,
    Facebook,
    Twitter,
} from "lucide-react";

const Contact = () => {
    return (
        <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-purple-50 to-pink-50">
            {/* Header */}
            <div className="bg-gradient-to-b from-[#8D35ba] to-[#8D35EA]  text-white py-16 text-center">
                <h1 className="text-4xl md:text-5xl font-extrabold">
                    Contact Us
                </h1>
                <p className="mt-3 text-white/90">
                    We’re here to help you plan your perfect trip
                </p>
            </div>

            {/* Content */}
            <div className="max-w-6xl mx-auto px-4 py-16 grid grid-cols-1 md:grid-cols-2 gap-10">
                {/* Left Info */}
                <div className="space-y-6">
                    <h2 className="text-2xl font-bold text-gray-800">
                        Get in Touch
                    </h2>
                    <p className="text-gray-600">
                        For bookings, support, or any queries — feel free to
                        contact us anytime.
                    </p>

                    {/* Address */}
                    <div className="bg-white rounded-2xl shadow-lg p-6 flex gap-4">
                        <MapPin className="text-indigo-600 mt-1" />
                        <div>
                            <p className="font-semibold">Address</p>
                            <p className="text-gray-600 text-sm">
                                Near Pro4 Socio, Spice Garden Layout,
                                <br />
                                Marathahalli, Bangalore,
                                <br />
                                Karnataka – 560037
                            </p>
                        </div>
                    </div>

                    {/* Phone */}
                    <div className="bg-white rounded-2xl shadow-lg p-6 flex gap-4">
                        <Phone className="text-indigo-600 mt-1" />
                        <div>
                            <p className="font-semibold">Phone</p>
                            <p className="text-gray-600 text-sm">
                                +91-7398747222
                            </p>
                        </div>
                    </div>

                    {/* Email */}
                    <div className="bg-white rounded-2xl shadow-lg p-6 flex gap-4">
                        <Mail className="text-indigo-600 mt-1" />
                        <div>
                            <p className="font-semibold">Email</p>
                            <p className="text-gray-600 text-sm">
                                info@boomontrip.com
                            </p>
                        </div>
                    </div>

                    {/* Website */}
                    <div className="bg-white rounded-2xl shadow-lg p-6 flex gap-4">
                        <Globe className="text-indigo-600 mt-1" />
                        <div>
                            <p className="font-semibold">Website</p>
                            <a
                                href="https://www.boomontrip.com"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-indigo-600 text-sm hover:underline"
                            >
                                www.boomontrip.com
                            </a>
                        </div>
                    </div>

                    {/* ✅ Social Media */}
                    <div className="bg-white rounded-2xl shadow-lg p-6">
                        <p className="font-semibold mb-3">Follow Us</p>
                        <div className="flex gap-5">
                            <a
                                href="https://www.instagram.com/boomontrip/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-pink-500 hover:scale-110 transition"
                            >
                                <Instagram size={24} />
                            </a>

                            <a
                                href="https://www.youtube.com/@BoomOnTrip"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-red-500 hover:scale-110 transition"
                            >
                                <Youtube size={24} />
                            </a>

                            <a
                                href="https://www.linkedin.com/company/boomontrip"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-600 hover:scale-110 transition"
                            >
                                <Linkedin size={24} />
                            </a>

                            <a
                                href="https://www.linkedin.com/company/boomontrip"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-600 hover:scale-110 transition"
                            >
                                <Facebook size={24} />
                            </a>

                                 <a
                                href="https://www.linkedin.com/company/boomontrip"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-600 hover:scale-110 transition"
                            >
                                <Twitter size={24} />
                            </a>
                        </div>
                    </div>
                </div>

                {/* Right Form */}
                <div className="bg-white rounded-3xl shadow-xl p-8">
                    <h3 className="text-xl font-bold mb-6">
                        Send Us a Message
                    </h3>

                    <form className="space-y-5">
                        <div>
                            <label className="text-sm text-gray-600">
                                Full Name
                            </label>
                            <input
                                type="text"
                                placeholder="Enter your name"
                                className="w-full mt-1 px-4 py-3 rounded-xl bg-gray-100 border border-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                            />
                        </div>

                        <div>
                            <label className="text-sm text-gray-600">
                                Email Address
                            </label>
                            <input
                                type="email"
                                placeholder="Enter your email"
                                className="w-full mt-1 px-4 py-3 rounded-xl bg-gray-100 border border-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                            />
                        </div>

                        <div>
                            <label className="text-sm text-gray-600">
                                Message
                            </label>
                            <textarea
                                rows="4"
                                placeholder="Type your message..."
                                className="w-full mt-1 px-4 py-3 rounded-xl bg-gray-100 border border-gray-200 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                            />
                        </div>

                        <button
                            type="submit"
                            className="w-full flex items-center justify-center gap-2 bg-gradient-to-r from-indigo-600 to-purple-600 text-white py-3 rounded-xl font-semibold hover:opacity-90"
                        >
                            <Send size={18} />
                            Send Message
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Contact;
